if (!customElements.get('slider-swiper-custom')) {
  class SliderSwiperCustom extends HTMLElement {
    connectedCallback() {
      this.classList.add('swiper');

      // If defer-init is set, wait for manual initialization
      if (this.dataset.deferInit === 'true') {
        return;
      }

      this.initSwiper();
    }

    initSwiper() {
      // Prevent double initialization
      if (this.swiper) return;
      
      // Make sure swiper-wrapper exists before initializing
      const swiperWrapper = this.querySelector('.swiper-wrapper');
      if (!swiperWrapper) {
        console.warn('SliderSwiperCustom: .swiper-wrapper not found, skipping initialization');
        return;
      }

      const itemsDesktop = parseFloat(this.dataset.itemsDesktop) || 4;
      const itemsMobile = parseFloat(this.dataset.itemsMobile) || 2;
      const showPagination = this.dataset.showPagination === 'true';
      const showArrows = this.dataset.showArrows === 'true';
      const loopEnabled = this.dataset.loop !== 'false';

      const swiperOptions = {
        slidesPerView: itemsMobile,
        spaceBetween: 10,
        loop: loopEnabled,
        zoom: true,
        breakpoints: {
          1024: {
            slidesPerView: itemsDesktop,
          },
        },
      };

      if (showPagination) {
        swiperOptions.pagination = {
          el: this.querySelector('.swiper-pagination'),
          type: 'fraction',
        };
      }

      if (showArrows) {
        swiperOptions.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        };
      }

      this.swiper = new Swiper(this, swiperOptions);
    }
  }

  customElements.define('slider-swiper-custom', SliderSwiperCustom);
}
